import React from 'react';
import { Section } from './ui/Section';
export function UpsellSection() {
  return <Section background="cream" className="opacity-90" data-id="element-224">
      <div className="text-center mb-10" data-id="element-225">
        <h3 className="text-lg font-semibold text-gray-500 uppercase tracking-widest" data-id="element-226">
          Completa tu experiencia
        </h3>
        <p className="text-gray-400 text-sm mt-2" data-id="element-227">
          (Opciones disponibles después de tu compra)
        </p>
      </div>

      <div className="grid gap-6 grid-cols-1 sm:grid-cols-3 opacity-75 hover:opacity-100 transition-opacity duration-300" data-id="element-228">
        <div className="bg-white p-5 rounded-lg border border-gray-200 text-center flex flex-col items-center" data-id="element-229">
          <img src="https://cdn.magicpatterns.com/uploads/tvXwvVCgFxTycZPtLPRDLz/ChatGPT_Image_8_feb_2026,_01_26_42_p.m..png" alt="50 Textos Clave para Calmar Conflictos" className="w-36 h-52 object-cover rounded-lg shadow-md mb-4" data-id="element-230" />
          <h4 className="font-bold text-gray-800 text-sm" data-id="element-231">
            50 Textos Clave para Calmar Conflictos con Él y Mantener la Paz
          </h4>
          <p className="text-sm text-gray-500 mt-1" data-id="element-232">Order Bump • $4.99</p>
        </div>

        <div className="bg-white p-5 rounded-lg border border-gray-200 text-center flex flex-col items-center" data-id="element-233">
          <img src="https://cdn.magicpatterns.com/uploads/dacZxbNYnFVXUVzGzxprxs/ChatGPT_Image_8_feb_2026,_01_26_39_p.m..png" alt="Errores de Comunicación que Arruinan Conversaciones" className="w-36 h-52 object-cover rounded-lg shadow-md mb-4" data-id="element-234" />
          <h4 className="font-bold text-gray-800 text-sm" data-id="element-235">
            Errores de Comunicación que Arruinan Conversaciones
          </h4>
          <p className="text-sm text-gray-500 mt-1" data-id="element-236">Order Bump • $4.99</p>
        </div>

        <div className="bg-white p-5 rounded-lg border border-gray-200 text-center flex flex-col items-center" data-id="element-237">
          <img src="https://cdn.magicpatterns.com/uploads/3So4tN9PBhmbP9bSUAHiUj/ChatGPT_Image_8_feb_2026,_02_28_41_p.m..png" alt="Relationship Scripts Vault™" className="w-36 h-52 object-cover rounded-lg shadow-md mb-4" data-id="element-238" />
          <h4 className="font-bold text-gray-800 text-sm" data-id="element-239">
            Relationship Scripts Vault™
          </h4>
          <p className="text-sm text-gray-500 mt-1" data-id="element-240">Upsell • $17.99</p>
        </div>
      </div>
    </Section>;
}